import { render, staticRenderFns } from "./ClassesList.vue?vue&type=template&id=7bf3c05b&scoped=true&"
import script from "./ClassesList.vue?vue&type=script&lang=ts&"
export * from "./ClassesList.vue?vue&type=script&lang=ts&"
import style0 from "./ClassesList.vue?vue&type=style&index=0&id=7bf3c05b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf3c05b",
  null
  
)

export default component.exports